import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";

const ARROW_SIZE = 40;

const withDialogPadding = (styles: Record<string, unknown>) => ({
  [BreakPointDesktop]: styles,
  [BreakPointTablet]: styles,
});

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialog: withDialogPadding({
    overflow: "hidden !important",
  }),
  dialogContent: withDialogPadding({
    marginInline: `${-theme.spacing.space48}px !important`,
    paddingInline: `${theme.spacing.space48}px !important`,
  }),
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    textAlign: "left",
  },
  /** Matches the size Dialog applies to its own title on desktop. */
  title: {
    textAlign: "center",
    [BreakPointDesktop]: {
      fontSize: "32px !important",
      lineHeight: "45px !important",
    },
  },
  bundleList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    maxHeight: 400,
    overflowX: "hidden",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    ...withDialogPadding({
      marginInline: -theme.spacing.space48,
    }),
  },
  bundle: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
    minWidth: 0,
  },
  bundleTitle: withDialogPadding({
    paddingInline: theme.spacing.space48,
  }),
  avatarList: {
    display: "flex",
    gap: theme.spacing.space24,
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    boxSizing: "border-box",
    overflowX: "auto",
    overflowY: "hidden",
    padding: theme.spacing.space4,
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "& > [role=button]": {
      width: `${ARROW_SIZE}px !important`,
      minWidth: `${ARROW_SIZE}px !important`,
      height: `${ARROW_SIZE}px !important`,
      alignSelf: "center",
    },
    "& > [role=button]:first-child": {
      marginRight: -(ARROW_SIZE + theme.spacing.space24),
    },
    "& > [role=button]:last-child": {
      marginLeft: -(ARROW_SIZE + theme.spacing.space24),
    },
    ...withDialogPadding({
      paddingInline: theme.spacing.space48,
      "& > [role=button]:first-child": {
        left: -(theme.spacing.space48 - theme.spacing.space8),
      },
      "& > [role=button]:last-child": {
        right: -(theme.spacing.space48 - theme.spacing.space8),
      },
    }),
  },
  avatar: {
    position: "relative",
    flex: "0 0 auto",
    width: 100,
    height: 100,
    [BreakPointMobile]: {
      width: 80,
      height: 80,
    },
    borderRadius: "50%",
    overflow: "hidden",
    cursor: "pointer",
  },
  avatarActive: {
    boxShadow: "0 0 0 3px #1877EB",
  },
  avatarSelected: {
    boxShadow: `0 0 0 3px ${theme.colors.TextDefault}`,
  },
  avatarImage: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));
